import React from 'react';
import './styles/Rent.css';
import AuthUserContext from './AuthUserContext';
import withAuthorization from './withAuthorization';
import URL from '../constants/url';
import ReactFlagsSelect from 'react-flags-select';
import Button from '@material-ui/core/Button';
//import css module
import 'react-flags-select/css/react-flags-select.css';
import { db, firestore } from '../firebase/firebase';
import { firebase } from '../firebase';
import Moment from 'react-moment';
// import 'moment-timezone';
import swal from 'sweetalert';
import isLoading from 'is-loading';

const axios = require('axios');

const NoNumber = () => (
  <div>
    <div className="alert alert-info" role="alert">
      You don't have any active numbers. You can buy using the button above.
    </div>
  </div>
);
//     firestore.collection("rent").doc("")

const NoMessage = () => (
  <div>
    <div className="alert alert-light" role="alert">
      You don't received any message yet.
    </div>
  </div>
);

const MessagesReceived = props => (
  <div id="messagesCont">
    {props.messages.map(e => {
      return (
        <div className="messageReceived">
          <div class="alert alert-light" role="alert">
            {console.log(e)}
            <p>From: {e.sender}</p>
            {e.messageText}
            <p>
              {/* <Moment date={e.receivedOn} parse="DD/MM/YYYY HH:mm" /> */}
              {e.receivedOn}
            </p>
          </div>
        </div>
      );
    })}
  </div>
);

class YourNumbers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedNumber: ''
    };
  }
  clickToSelectNumber = e => {
    console.log(`Selected number: ${e}`);
    this.setState({
      selectedNumber: e
    });
  };

  // componentDidMount() {
  //   if (Object.keys(this.props.numbers).length > 0) {
  //     // this.setState({
  //     //   selectedNumber: Object.keys(this.props.numbers)[0]
  //     // });
  //   }
  // }

  render() {
    return (
      <div>
        {/* {Object.keys(this.props.numbers).forEach(e => {
          console.log(e);
        })} */}
        {console.log(this.props.numbers)}
        <div className="row" id="numberPaneRow">
          <div className="col col-12 col-md-4">
            <h5>Your Numbers</h5>
            <div className="blue-line" />
            <p>Select your number below</p>
            <div id="numbersContainer">
              {Object.keys(this.props.numbers).map((number, index) => {
                console.log(this.props.numbers[number].expiryDate);
                return (
                  <div
                    className={`number d-flex justify-content-between ${
                      this.state.selectedNumber === number ? 'active' : null
                    }`}
                    onClick={() => {
                      this.clickToSelectNumber(number);
                    }}
                  >
                    <p>+{number}</p>
                    <div>
                      {console.log(this.props.numbers[number].expiryDate)}
                      <i
                        className="material-icons"
                        title={`Expiry date: ${
                          this.props.numbers[number].expiryDate
                        }`}
                      >
                        help_outline
                      </i>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="col col-12 col-md-8">
            <h5>Incoming Messages</h5>
            <div className="blue-line" />
            <div>
              {/* <p className="messageReceived">asdasdasf</p>
              <p className="messageReceived">asdasdasf</p>
              <p className="messageReceived">asdasdasf</p> */}
              {this.state.selectedNumber &&
              this.props.numbers[this.state.selectedNumber].messagesReceived &&
              this.props.numbers[this.state.selectedNumber].messagesReceived
                .length > 0 ? (
                // <div>mesaj varm</div>
                <MessagesReceived
                  messages={
                    this.props.numbers[this.state.selectedNumber]
                      .messagesReceived
                  }
                />
              ) : (
                <NoMessage />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const countryCodeMap = {
  GB: 'United Kingdom(+44)',
  US: 'United States(+1)',
  BE: 'Belgium(+32)'
};
class BuyNewNumber extends React.Component {
  state = {
    open: false,
    buyCountrySelected: ''
  };

  getUpdateFromChild(e) {
    e.preventDefault();
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  buyNewNumber = () => {
    console.log('inside');
    let buyQuery = {};
    buyQuery['country'] = this.state.buyCountrySelected;
    buyQuery['uid'] = this.props.user;
    isLoading().loading();
    if (this.state.buyCountrySelected != '') {
      swal({
        title: `Do you want to buy a ${
          countryCodeMap[this.state.buyCountrySelected]
        } number?`,
        // text:
        //   'Once you click buy, the amount will be deducted from your balance.',
        icon: 'info',
        buttons: ['Cancel', 'Yes']
      }).then(goAndBuy => {
        if (goAndBuy) {
          isLoading().loading();

          axios
            .post(URL + '/rent', buyQuery)
            .then(response => {
              console.log(response.data);
              if (response.data.status) {
                // alert(
                //   'Order is successfull. Number will be available on your dashboard once setup is complated'
                // );
                isLoading().remove();
                swal(
                  'Success!',
                  'Number will be available on your dashboard once setup is complated',
                  'success'
                );
              } else {
                // alert(response.data.error);
                isLoading().remove();
                swal('Error!', `${response.data.error}`, 'error');
              }
            })
            .catch(err => {
              isLoading().remove();
              console.log(err);
            });
        } else {
        }
      });
    } else {
      swal('Upps!', 'You should select a country.', 'info');
    }
  };

  //onSelect Method
  onSelectFlag = countryCode => {
    console.log(countryCode);
    this.setState({
      buyCountrySelected: countryCode
    });
  };

  render() {
    return (
      <div>
        <div className="d-flex justify-content-center align-items-center">
          <ReactFlagsSelect
            countries={['US', 'GB', 'BE']}
            searchable={true}
            customLabels={{
              US: '[+1] USA - $5',
              GB: '[+44] UK - $5',
              BE: '[+32] Belgium - $4'
            }}
            optionsSize={15}
            onSelect={this.onSelectFlag}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              this.buyNewNumber();
            }}
          >
            Buy a Number
          </Button>          
        </div>
        <p
          className="d-flex justify-content-center"
          style={{ fontSize: '11px', marginTop: '10px' }}
        >
          1 month duration. You can extend it later
        </p>
      </div>
    );
  }
}

class RentPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasActiveNumber: false
    };
  }
  componentDidMount() {
    // console.log(this.props.aa.uid);

    let uid = this.props.aa.uid;
    firestore
      .collection('rent')
      .doc(uid)
      .onSnapshot(doc => {
        if (doc.data() && Object.keys(doc.data()).length > 0) {
          this.setState({
            hasActiveNumber: true,
            NumbersData: doc.data()
          });
        }
        // console.log('Current data: ', doc.data());
        console.log('state:', this.state);
        // console.log(Object.keys(doc.data()).length);
      });
  }
  render() {
    const { authUser } = this.props;
    return (
      // it gets access to the authenticated user object via React’s
      // context by using the Consumer component
      <AuthUserContext.Consumer>
        {/* authUser is accessible because its created by the Provider (Context
  API)-Higher order component */}
        {authUser => (
          <div id="rentContainer">
            <BuyNewNumber user={this.props.aa.uid} />
            <hr />
            <div className="container">
              {console.log(this.state)}
              {this.state.hasActiveNumber === true ? (
                <YourNumbers auth={authUser} numbers={this.state.NumbersData} />
              ) : (
                <NoNumber />
              )}
            </div>
          </div>
        )}
      </AuthUserContext.Consumer>
    );
  }
}

// checks if the authUser object is not null
const authCondition = authUser => !!authUser;

// export default withAuthorization(authCondition)(HomePage);
export default withAuthorization(authCondition)(RentPage);
